export const INFO_PAGES = {
  faq: { title: "Domande frequenti", eyebrow: "Assistenza" },
};

export const LEGAL_SLUGS = ["termini", "privacy", "cookie", "resi", "spedizioni", "pagamenti"];
